import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './userStore'
import cartsStore from './cartsStore'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user: userStore,
        carts: cartsStore
    }
})
